import { Link } from "react-router-dom";
import { Phone, Home as HomeIcon } from "lucide-react";
import { WhatsAppIcon } from "@/components/site/WhatsAppIcon";
import { LOGO, PHONE_TEL, PHONE_DISPLAY, waLink, onCall, onWhatsApp } from "@/lib/site";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-ink text-white grid place-items-center px-6 grain relative">
      <div className="relative z-10 text-center max-w-lg">
        <img src={LOGO} alt="DG Guinchos Jundiaí" className="h-20 w-auto mx-auto" />
        <div className="mt-8 font-display text-[7rem] leading-none font-black text-brand">404</div>
        <h1 className="mt-2 font-display text-3xl md:text-4xl font-black">Página não encontrada</h1>
        <p className="mt-4 text-zinc-400">
          A página que você procura não existe. Mas se o seu veículo parou, é só chamar a DG Guinchos — atendemos 24 horas.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-white hover:bg-zinc-200 text-black font-display font-bold uppercase tracking-wider px-7 py-4 rounded-sm transition-all active:scale-95"
          >
            <HomeIcon className="h-5 w-5" /> Voltar ao Início
          </Link>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => onWhatsApp("404")}
            className="inline-flex items-center justify-center gap-2 bg-wapp hover:bg-wapp-hover text-black font-display font-bold uppercase tracking-wider px-7 py-4 rounded-sm transition-all active:scale-95"
          >
            <WhatsAppIcon className="h-6 w-6" /> WhatsApp 24h
          </a>
        </div>
        <a href={`tel:${PHONE_TEL}`} onClick={() => onCall("404")} className="mt-6 inline-flex items-center gap-2 text-xl font-display font-bold text-white hover:text-brand">
          <Phone className="h-5 w-5 text-brand" /> {PHONE_DISPLAY}
        </a>
      </div>
    </div>
  );
}
